import { useState } from 'react';

export function useContextMenu() {
  // eslint-disable-next-line no-unused-vars
  const [showTooltip, setShowTooltip] = useState({ show: false, text: '', x: 0, y: 0 });
  const [contextMenu, setContextMenu] = useState({
    show: false,
    x: 0,
    y: 0,
    selectedText: '',
    showText: false
  });
  const [translation, setTranslation] = useState(null);

  const handleTextSelection = () => {
    const selectedText = window.getSelection().toString().trim();
    if (selectedText) {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        const rect = range.getBoundingClientRect();
        setContextMenu({
          show: true,
          x: rect.left + rect.width / 2,
          y: rect.top - 30,
          selectedText: selectedText,
          showText: true
        });
      }
    } else {
      setContextMenu({ show: false, x: 0, y: 0, selectedText: '', showText: false });
    }
  };

  // Context menu handlers (keep for backward compatibility)
  const handleContextMenu = (e) => {
    e.preventDefault();
    const selectedText = window.getSelection().toString().trim();
    if (selectedText) {
      setContextMenu({
        show: true,
        x: e.clientX,
        y: e.clientY,
        selectedText: selectedText,
        showText: true
      });
    }
  };

  const handleCloseContextMenu = () => {
    setContextMenu({ show: false, x: 0, y: 0, selectedText: '', showText: false });
    setTranslation(null);
  };

  return {
    showTooltip, setShowTooltip,
    contextMenu, setContextMenu,
    translation, setTranslation,
    handleTextSelection,
    handleContextMenu,
    handleCloseContextMenu,
  };
}
